const PATHS = {
    allAisle: '/allAisle',
    aisleSequence: '/aisleSequence',
    bin: '/bin',
    ledController: '/ledController',
};

const API_NAMES = {
    ledTesterApi: 'ledTesterApi',
};

const BIN_LABEL_STYLES = {
    EU: 'eu',
    NA: 'us',
    IN_SC: 'IN_SC'
};

const COLOR_MAP = {
    RED: '0xFFFF0000',
    GREEN: '0xFF00FF00',
    BLUE: '0xFF0000FF',
    CYAN: '0xFF00FFFF',
    MAGENTA: '0xFFFF00FF',
    YELLOW: '0xFFFFFF00',
    WHITE: '0xFFFFFFFF'
};

const BIN_ON_DURATION_MS = 800;

const AISLE_ON_DURATION_MS = 1000;

export {PATHS, API_NAMES, BIN_LABEL_STYLES, BIN_ON_DURATION_MS, AISLE_ON_DURATION_MS, COLOR_MAP};



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/bintester/util/constant.js